import { render, staticRenderFns } from "./TransmitByAp.vue?vue&type=template&id=460aa21e&scoped=true&"
import script from "./TransmitByAp.vue?vue&type=script&lang=js&"
export * from "./TransmitByAp.vue?vue&type=script&lang=js&"
import style0 from "./TransmitByAp.vue?vue&type=style&index=0&id=460aa21e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460aa21e",
  null
  
)

export default component.exports